import React from "react";
import Template from "../../../components/Dashboard/Template";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import TableData from "../../../dumyData/education/EducationAddmissionReq.json";

const diplayRows = ["ed_quick_req_date_time", "ed_new_st_req_details"];

const AdmissionRequest = () => {
  return (
    <Template
      primaryHeading={"Quick Admission Report"}
      secondaryHeading={"Latest"}
    >
      <DashboardTable
        showHeader={false}
        tableData={TableData}
        diplayRows={diplayRows}
      />
    </Template>
  );
};

export default AdmissionRequest;
